
/**
 * @file 页面布局
 * @author sunyingying01
 */

import React, {useState} from 'react';
import {Layout, Button} from 'antd';
import {CloseCircleOutlined} from '@ant-design/icons';
import {Outlet} from 'react-router-dom';
import styles from './index.module.less';

const {Header, Content} = Layout;

const MainLayout: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    return (
        <Layout className={styles.mainLayout}>
            <Header className={styles.header}>
                <h2>Famou</h2>
                <Button className={styles.loginBtn} onClick={openModal}>Log in</Button>
            </Header>
            <Content>
                <Outlet />
            </Content>
            {isOpen && (
                <div className={styles.loginModal}>
                    <CloseCircleOutlined className={styles.closeIcon} onClick={closeModal} />
                    <iframe src="https://login.bce.baidu.com" width={600} height={600}></iframe>
                </div>
            )}
        </Layout>
    );
};

export default MainLayout;
